import { useState } from "react";
import { Play } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { useContent, awardPoints } from "../lib/api";
import { Dialog, DialogContent, DialogTitle } from "../components/ui/dialog";

export default function Videos() {
  const { data: videos } = useContent("videos");
  const [filter, setFilter] = useState("All");
  const [active, setActive] = useState(null);
  const cats = ["All", ...Array.from(new Set(videos.map((v) => v.category)))];
  const shown = filter === "All" ? videos : videos.filter((v) => v.category === filter);

  return (
    <div data-testid="videos-page">
      <PageHeader overline="Free Training" title={<>Video<br />Library</>}
        subtitle="Technique breakdowns, follow-along workouts and transformation stories — all free." />
      <section className="mx-auto max-w-[1400px] px-5 lg:px-8 py-14 md:py-20">
        <div className="flex flex-wrap gap-2.5 mb-10">
          {cats.map((c) => (
            <button key={c} data-testid={`video-filter-${c.toLowerCase()}`} onClick={() => setFilter(c)}
              className={`px-5 py-2.5 rounded-full text-xs uppercase tracking-[0.12em] font-bold border transition-colors ${filter === c ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary"}`}>{c}</button>
          ))}
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {shown.map((v, i) => (
            <Reveal key={v.id} delay={(i % 3) * 0.06}>
              <button data-testid="video-card" onClick={() => { setActive(v); awardPoints("watch_video", v.id); }} className="group block w-full text-left border border-border rounded-lg overflow-hidden bg-card hover:border-primary transition-colors">
                <div className="relative aspect-video overflow-hidden">
                  <img src={`https://img.youtube.com/vi/${v.youtube_id}/hqdefault.jpg`} alt={v.title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 grid place-items-center bg-black/30 group-hover:bg-black/10 transition-colors">
                    <div className="grid place-items-center w-14 h-14 rounded-full bg-primary group-hover:scale-110 transition-transform"><Play size={22} className="text-white fill-white" /></div>
                  </div>
                </div>
                <div className="p-5">
                  <span className="text-[10px] uppercase tracking-[0.15em] text-primary font-bold">{v.category}</span>
                  <h3 className="font-display font-700 uppercase text-2xl tracking-tight mt-1">{v.title}</h3>
                  <p className="text-muted-foreground text-sm mt-1 line-clamp-2">{v.description}</p>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </section>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden">
          {active && (<div>
            <DialogTitle className="sr-only">{active.title}</DialogTitle>
            <div className="aspect-video w-full bg-black">
              <iframe data-testid="video-iframe" className="w-full h-full" src={`https://www.youtube.com/embed/${active.youtube_id}?autoplay=1`} title={active.title} allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
            </div>
            <div className="p-6">
              <span className="text-[10px] uppercase tracking-[0.15em] text-primary font-bold">{active.category}</span>
              <h3 className="font-display font-700 uppercase text-3xl tracking-tight mt-1">{active.title}</h3>
              <p className="text-muted-foreground mt-2">{active.description}</p>
            </div>
          </div>)}
        </DialogContent>
      </Dialog>
    </div>
  );
}
